import Styles from './InternshipCertificateGenerator.module.scss';
import React, { useContext } from 'react';
// Module imports.
import _ from 'lodash';
// Components import
import { Logo, AuthContext } from 'components/lib';
// Assets import.
import nasscomlogo from 'assets/icons/nasscomlogo.png';

/**
 * @param {string} firstName First Name of the user for whom certificate has to be generated
 * @param {string} lastName Last Name of the user for whom certificate has to be generated
 * @param {string} internshipName Name of the internship program
 * @param {string} issueDate Date of the certificate issuance
 * @param {string} internshipCertId Unique certificate ID
 * @param {string} logo Logo URL - if provided, takes priority over NASSCOM logo
 */
export const InternshipCertificateGenerator = React.forwardRef(
    ({ id, firstName, lastName, internshipName, issueDate, internshipCertId = '', logo, ...props }, ref) => {
        const authContext = useContext(AuthContext);
        const isProdEnv = process.env.REACT_APP_PRODUCTION;
        // Determine which logo to display - data.logo takes priority, fallback to NASSCOM logo
        const orgLogo = logo;
        const nasscomLogo = nasscomlogo;

        return (
            <>
                <div ref={ref} className={Styles.container} id={id}>
                    <img 
                        src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}/topos-icons/global/certificate_watermark.png`} 
                        style={{ display: isProdEnv === "true" ? "none" : "" }} 
                        alt="Watermark" 
                        className={Styles.watermark} 
                    />

                    {/* TG background logo */}
                    <img src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}/topos-icons/org_logo/79e0e06f-c4fc-4062-9615-2376e4e4a204/org_logo.png`}
                        alt="TopGrep"
                        className={Styles.bgImage}
                    />

                    {/* Top red bar */}
                    <div className={Styles.topBar}></div>

                    {/* AIVAGAM and org logo */}
                    <div className={Styles.topLogos}>
                        <div className={Styles.orgLogo}>
                            {orgLogo && <img
                                src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${orgLogo}`}
                                alt="Org Logo"
                            />}
                        </div>
                        <div>
                            <Logo color="short" className={Styles.aivagamLogo} />
                        </div>
                    </div>

                    {/* Main content */}
                    <div className={Styles.content}>
                        <h1 className={Styles.title}>Certificate</h1>
                        <p className={Styles.subtitle}>OF INTERNSHIP COMPLETION</p>
                        <p className={Styles.certifyText}>THIS IS TO CERTIFY THAT</p>
                        <h2 className={Styles.name}>
                            {_.startCase(_.toLower(firstName))} {_.startCase(_.toLower(lastName))}
                        </h2>
                        <div className={Styles.underline} />
                        <p className={Styles.completedText}>
                            has successfully completed the internship program
                        </p>
                        <h3 className={Styles.internshipName}>{internshipName}</h3>
                        <p className={Styles.desc}>
                            <i>
                                demonstrating proficiency in the required competencies and successfully completing
                                all assigned projects, courses, and certifications <b>on aivagam</b>.
                            </i>
                        </p>
                    </div>
                    {/* Footer Row */}
                    <div className={Styles.footerRow}>

                        {/* Left: QR */}
                        <div className={Styles.left}>
                            {props.qrCode}
                            {internshipCertId && (
                                <p className={Styles.certId}>Cert ID: {internshipCertId}</p>
                            )}
                        </div>

                        {/* Right: NASSCOM */}
                        <div className={Styles.right}>
                            <img src={nasscomLogo} alt="NASSCOM" />
                        </div>
                    </div>

                    {/* Footer row center: Issued details */}
                    <div className={Styles.center}>
                        <p><u>Issued By</u></p>
                        <p>
                            {authContext?.user?.accounts[0]?.whitelabel
                                ? authContext.user.accounts[0].name
                                : 'TopGrep Tech Pvt Ltd'}
                        </p>
                        <p>Issued On {issueDate}</p>
                    </div>
                    {/* Bottom Bars */}
                    <div className={Styles.bottomRedBar}></div>
                    <div className={Styles.bottomBlueBar}></div>
                </div>
            </>
        );
    }
);